import gql from 'graphql-tag';

export const desktopAppClientFragment = gql`
  fragment desktopAppClientFragment on DesktopAppClient {
    dokkioClass
    id
    accountID
    machineID
    machineName
    platform
  }
`;
export default desktopAppClientFragment;
